import { type NodeProps, Handle } from "reactflow";
import cn from "classnames";
import Icon from "app/components/shared/Icon";
import BaseNode from "./BaseNode";
import * as HoverCard from "app/components/Playground/HoverCard";

const RootNodeIcon = () => (
  <div aria-hidden={true} className="bg-green-700 p-2 rounded-lg">
    <Icon className="text-white h-6 w-6" icon="heroicons/solid/play" />
  </div>
);

export default function RootNode(props: NodeProps) {
  return (
    <HoverCard.Trigger
      className="group"
      payload={{
        id: props.id,
        content: (
          <HoverCard.Content id={props.id} label="Trigger event">
            You can configure specific events to run a pipeline, such as when a
            new commit is pushed, via an API webhook, on a schedule, manually
            via the UI or CLI, and more.
          </HoverCard.Content>
        ),
      }}
    >
      <BaseNode
        {...props}
        label="Trigger event"
        icon={<RootNodeIcon />}
        className="cursor-help group-focus:bg-green-100 group-hover:bg-green-100"
      />
      {props.sourcePosition && (
        <Handle
          type="source"
          position={props.sourcePosition}
          isConnectable={props.isConnectable}
          className={cn({ "opacity-0": !props.isConnectable })}
        />
      )}
    </HoverCard.Trigger>
  );
}
